module.exports = __webpack_public_path__ + "img/u_filter.408fcb91.svg";